module.exports = __webpack_public_path__ + "images/edges_grey@2x.png?ebc85c7d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edges_grey@2x.png
// module id = 619
// module chunks = 7